import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';  // Make sure this line is present
import App from './App';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars, faCog, faMoon, faSignOutAlt, faUser, faRobot, faPaperPlane, faTimes, faHistory, faCopy, faDownload, faCheck, faExchangeAlt, faComments, faPlus, faTrash, faEdit, faSearch, faBrain, faPencilAlt, faBullseye, faHashtag, faHandshake, faTrophy, faUserCog, faPaperclip, faImage, faFile, faQuestionCircle, faCode, faCodeBranch, faPalette, faVideo, faEnvelope, faRocket, faChartLine } from '@fortawesome/free-solid-svg-icons';
import { faGoogle, faGithub } from '@fortawesome/free-brands-svg-icons';
import { StyleSheetManager } from 'styled-components';
import { app, analytics } from './firebase';

library.add(faBars, faCog, faMoon, faSignOutAlt, faUser, faRobot, faPaperPlane, faTimes, faHistory, faCopy, faDownload, faCheck, faExchangeAlt, faComments, faPlus, faTrash, faEdit, faSearch, faBrain, faPencilAlt, faBullseye, faHashtag, faHandshake, faTrophy, faUserCog, faPaperclip, faImage, faFile, faQuestionCircle, faCode, faCodeBranch, faPalette, faVideo, faEnvelope, faRocket, faChartLine, faGoogle, faGithub);

console.log('Initial CSS variables:', {
  primaryColor: getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim(),
  secondaryAccent: getComputedStyle(document.documentElement).getPropertyValue('--secondary-accent').trim(),
  primaryColorDark: getComputedStyle(document.documentElement).getPropertyValue('--primary-color-dark').trim(),
  accentColor: getComputedStyle(document.documentElement).getPropertyValue('--accent-color').trim(),
  backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--background-color').trim(),
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StyleSheetManager shouldForwardProp={(prop) => prop !== 'theme'}>
      <App />
    </StyleSheetManager>
  </React.StrictMode>
);